import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "button" ]

  initialize() {
    this.currentScheme = localStorage.getItem('scheme')
  }

  buttonTargetConnected(el) {
    el.addEventListener('click', this.toggle)
  }

  buttonTargetDisconnect(el) {
    el.removeEventListener('click', this.toggle)
  }

  toggle = () => {
    if (this.currentScheme == 'dark') {
      this.currentScheme = 'light'
    } else {
      this.currentScheme = 'dark'
    }
  }

  set currentScheme(value) {
    if (!value) { return }

    localStorage.setItem('scheme', value)
    document.documentElement.setAttribute('data-theme', value)
  }

  get currentScheme() {
    return document.documentElement.getAttribute('data-theme')
  }

  get darkSystem() {
    return window.matchMedia('(prefers-color-scheme: dark)').matches
  }
}
